'use strict';

var novicell = novicell || {};

novicell.brandSlider = novicell.brandSlider || new function () {
    this.init = function(data) {
        const brandSlider = document.querySelectorAll('.brand-slider');

        if(!brandSlider) {
            return;
        }

        for (let i = 0; i < brandSlider.length; i++) {
            const slideshowElm = brandSlider[i];
            const flkty = new Flickity( slideshowElm, {
                // options
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                pageDots: false,
                groupCells: 1
            });
            
        }

    };
}();